import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import tailwind from "./tailwind.css?url";
import App from "./App.tsx";
import { BrowserRouter, createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router";
import { ErrorBoundary } from "react-error-boundary";
import "dayjs/locale/fr";
import dayjs from "dayjs";
import type { Notification, NotificationResponse } from "./types/expo-notifications.ts";
dayjs.locale("fr");

window.onAppVersion = (version: string) => {
  console.log("onAppVersion", version);
  window.localStorage.setItem("appVersion", version);
};

// window.onNotificationReceived = (notificationStringified: string) => {
//   const notification: Notification = JSON.parse(notificationStringified);
//   const url = notification.request.content.data.url;
//   alert(`setting navigateToUrl from notification: ${url}`);
//   window.localStorage.setItem("navigateToUrl", url);
// };

// window.onNotificationResponseReceived = (responseStringified: string) => {
//   const response: NotificationResponse = JSON.parse(responseStringified);
//   const url = response.notification.request.content.data.url;
//   alert(`setting navigateToUrl from notification response: ${url}`);
//   window.localStorage.setItem("navigateToUrl", url);
// };

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: "https://1b96716415b18f110c45dd17cb5fc940@o117731.ingest.us.sentry.io/4506260130496512",
    environment: `app-react-router-${import.meta.env.VITE_ENV}`,
    release: __VITE_BUILD_ID__,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    maxValueLength: 10000,
    normalizeDepth: 10,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.05,
    ignoreErrors: [
      "Network request failed",
      // "Failed to fetch",
      "NetworkError",
      // ???
      "withrealtime/messaging",
      // This error seems to happen only in firefox and to be ignorable.
      // The "fetch" failed because user has navigated.
      // Since other browsers don't have this problem, we don't care about it,
      // it may be a false positive.
      "AbortError: The operation was aborted",
      // Sur safari, on a des erreur de type "TypeError: cancelled" qui seraient liées
      // au bouton "X" (ou refresh) pressé pendant un fetch. Il semblerait que la meilleure
      // approche soit de les ignorer.
      // Cf: https://stackoverflow.com/a/60860369/978690
      "TypeError: cancelled",
      "TypeError: annulé",
    ],
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <link rel="shortcut icon" href="/favicon.svg" type="image/x-icon" />
    <link rel="stylesheet" href={tailwind} />

    <BrowserRouter>
      <ErrorBoundary
        // FallbackComponent={UnexpectedError}
        fallbackRender={({ error }) => {
          Sentry.captureException(error);
          return <div>Error</div>;
        }}
        onError={(error, componentStack) => {
          Sentry.captureException(error, { extra: { componentStack } });
        }}
        onReset={(details) => {
          console.log("plouf");
          console.log({ details });
          // Reset the state of your app so the error doesn't happen again
        }}
      >
        <App />
      </ErrorBoundary>
    </BrowserRouter>
  </StrictMode>
);
